import { defineMessages } from "react-intl";

const PREFIX = "BulkExportPage";
export const messages = defineMessages({
  searchPlaceholder: {
    id: `${PREFIX}.searchPlaceholder`,
    defaultMessage: "Search...",
  },
});
